import { useMemo } from 'react';
import { Store } from '../codegen/graphql';

export function useHighestCostPriceStore(
    advertisingZoneStores: Store[],
): string | null {
    return useMemo(() => {
        const highest = advertisingZoneStores.reduce<{
            storeId: string | null;
            costPrice: number;
        }>(
            (current, store) => {
                const { productAvailability } = store;
                if (!productAvailability?.isLive) {
                    return current;
                }
                const { costPrice } = productAvailability;
                if (costPrice == null || !Number.isFinite(costPrice)) {
                    return current;
                }
                if (costPrice <= current.costPrice) {
                    return current;
                }
                return { storeId: store.id, costPrice };
            },
            { storeId: null, costPrice: -Infinity },
        );

        return highest.storeId;
    }, [advertisingZoneStores]);
}
